<template>
  <div class="d-bar">
    <div class="container">
      <div class="row">
        <div
          class="col-2 offset-md-8 template"
          @click="showTemplate = !showTemplate"
        >
          {{ t("message.templates") }}
        </div>
      </div>
    </div>
  </div>
  <div class="container-xl">
    <div id="greeting" class="d-none d-sm-none d-md-flex row">
      <p class="col-12">{{ t("message.welcome") }}</p>
      <p class="w-50" style="margin: auto" v-html="t('message.oldGTD')"></p>
      <p
        class="col-12 mt-2"
        style="margin: auto"
        v-html="t('message.serviceBeschriftung')"
      ></p>
    </div>

    <div class="row d-none d-sm-none d-md-flex selection-wrapper">
      <div class="col-sm-2 col-xl-3">
        <div
          class="project-selection"
          @click="showProjectName = !showProjectName"
        >
          <p>{{ t("message.newProj") }}</p>
        </div>
        <div v-if="showProjectName">
          <div class="py-2 text-center">
            {{ t("message.chooseProjectName") }}
          </div>
          <input
            type="textfield"
            :placeholder="t('message.projectname')"
            class="form-control projectname"
            :value="currentProjectName"
            @input="changeProjectName"
            @keyup.enter="selectNewGT"
          />
        </div>

        <button
          class="btn btn-outline-lcn my-2"
          @click="selectNewGT"
          v-if="currentProjectName.length > 0"
        >
          {{ t("message.next") }}
        </button>
      </div>
      <div class="col-sm-2 col-xl-3">
        <div class="project-selection" @click="importProject">
          <p>{{ t("message.importProject") }}</p>
        </div>
      </div>
    </div>
    <design-template
      v-if="showTemplate"
      @close="showTemplate = false"
    ></design-template>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { computed, ref } from "vue";
import DesignTemplate from "../views/components/DesignTemplate.vue";
export default {
  components: { DesignTemplate },
  setup() {
    const { t } = useI18n({ useScope: "global" });
    const store = useStore();
    const currentProjectName = computed(() => store.getters.currentProjectName);
    const showProjectName = ref(false);
    const showTemplate = ref(false);
    function changeProjectName(event) {
      store.dispatch("setProjectName", event.target.value);
    }
    const router = useRouter();
    function selectNewGT() {
      router.push("/select");
    }
    function importProject() {
      router.push("/list");
    }

    return {
      selectNewGT,
      importProject,
      t,
      currentProjectName,
      changeProjectName,
      showProjectName,
      showTemplate,
    };
  },
};
</script>

<style lang="scss" scoped>
.swiper-container {
  height: 100%;
}
@media (min-resolution: 108dpi) {
  .project-selection {
    min-height: 130px !important;
    max-width: 130px !important;
    > p {
      font-size: 1.125rem !important;
    }
  }
  .selection-wrapper {
    margin-top: 5%;
    justify-content: center;
  }
  h4 {
    font-size: 1.125rem !important;
  }
}

@media (max-width: 1360px) and (max-resolution: 96dpi) {
  .project-selection {
    height: 180px;
    width: 180px;
    > p {
      font-size: 1.725rem;
    }
  }
  .selection-wrapper {
    margin-top: 15%;
    justify-content: space-around;
  }
}
@media (min-width: 1361px) and (max-resolution: 96dpi) {
  .project-selection {
    height: 230px;
    width: 230px;
    > p {
      font-size: 2rem;
    }
  }
  .selection-wrapper {
    margin-top: 15%;
    justify-content: space-around;
  }
}
.project-selection {
  margin: auto;
  background: #ffde00;
  border: solid #bdbdbd 0;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  padding: 5px;
  > p {
    color: #000000;
    font-weight: bold;
    width: 100%;
  }
  &:hover {
    cursor: pointer;
    background: #ffd600;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  }
}

.d-bar {
  height: 50px;
  padding: 10px;
  background-color: #fff;
  line-height: 30px;
}
.template {
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
